<template>
  <div class="rs-segment-info">
    <!-- In the query-overview layout the save-as prompt lives in
         unsaved-changes-alert.vue; the partner-section flow keeps its
         update link here. -->
    <div
      v-if="
        (!segment || !segment.id) &&
        (partnerSegmentName || !queryOverviewEnabled)
      "
      class="sf-bg-warning-subtle-2 tw-p-4"
      :class="
        inFloatingSidepane
          ? 'tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1'
          : 'sf-layer-border-bottom'
      "
    >
      <a
        v-if="!partnerSegmentName"
        class="sf-btn"
        @click="openSaveSegmentModal"
      >
        <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
        <span>{{ I18n.t('companies_overview.segments_new.save_as') }}</span>
      </a>

      <a
        v-if="partnerSegmentName"
        class="sf-btn"
        data-testid="update-partner-segment"
        @click="updatePartnerSegment(partnerSegmentID)"
      >
        <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
        <span>Update "{{ partnerSegmentName }}" in Partner Section</span>
      </a>
    </div>

    <!-- In the query-overview layout this lives in unsaved-changes-alert.vue -->
    <div
      v-if="isSegmentModified && !queryOverviewEnabled"
      class="sf-bg-warning-subtle-2 tw-p-4"
      :class="
        inFloatingSidepane
          ? 'tw-border-0 tw-border-b tw-border-solid tw-border-sf-slate-lighter-1'
          : 'sf-layer-border-bottom'
      "
    >
      <div class="sf-text sf-c-warning sf-below-3">
        {{ I18n.t('companies_overview.segments_new.filters_have_changed') }}
      </div>
      <div class="sf-level sf-level-vertical sf-level-small">
        <div class="sf-level-item">
          <div
            v-if="canUpdateSegment && (!segment || !segment.recommended)"
            v-tooltip="
              marketSegment
                ? I18n.t(
                    'companies_overview.segments_new.market_segment_cannot_save'
                  )
                : ''
            "
            class="sf-inline-block"
          >
            <a
              :class="{ 'sf-disabled': marketSegment }"
              :disabled="marketSegment"
              class="sf-btn rs-update-segment"
              @click="updateSegmentWithConfirm"
            >
              <div
                class="
                  sf-btn-icon-left
                  fa fa-solid fa-triangle-exclamation
                  sf-c-warning-light-1
                "
              ></div>
              <span>{{
                I18n.t('companies_overview.segments_new.update')
              }}</span>
            </a>
          </div>
        </div>

        <div class="sf-level-item rs-create-segment">
          <a class="sf-btn" @click="openSaveAsSegmentModal">
            <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
            <span>{{
              I18n.t('companies_overview.segments_new.save_as_new')
            }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useInsightsRootStore } from '@app/insights/store/insights-root'
import { INSIGHTS_LAYOUT_CONTEXT_KEY } from '@app/insights/composables/use-insights-layout-context'

export default {
  inject: {
    insightsLayoutContext: {
      from: INSIGHTS_LAYOUT_CONTEXT_KEY,
      default: () => ({ inFloatingSidepane: false }),
    },
  },

  computed: {
    inFloatingSidepane() {
      return this.insightsLayoutContext.inFloatingSidepane
    },
    ...mapPiniaState(useSegmentsStore, ['segment', 'isSegmentModified']),
    ...mapPiniaState(useInsightsRootStore, ['lite', 'queryOverviewEnabled']),

    marketSegment() {
      return !!this.segment.partner
    },

    partnerSegmentID() {
      return this.$route.query.ms_id
    },

    partnerSegmentName() {
      return this.partnerSegmentID && this.$route.query.ms_name
    },
    canUpdateSegment() {
      return this.segment?.permissions.update
    },
  },
  methods: {
    ...mapPiniaActions(useSegmentsStore, [
      'openSaveSegmentModal',
      'openSaveAsSegmentModal',
      'updateSegment',
      'updatePartnerSegment',
    ]),

    updateSegmentWithConfirm() {
      if (this.marketSegment) return
      window.sfConfirm({
        question: I18n.t('companies_overview.segments_new.confirm_update'),
        onConfirm: async () => {
          try {
            await this.updateSegment()
          } catch (e) {
            alert(e.body.errorMessage)
          }
        },
      })
    },
  },
}
</script>
